<template>
    <div class="AccountInfo">
        <div class="BlockCategory">
            <span class="Title">
                Personal Information
            </span>
            <div class="Data">
                <div class="Param">
                    <span class="Label">
                        Name
                    </span>
                    <span class="Datum--Text">
                        {{ this.localInfo.full_name }}
                    </span>
                </div>
                <div class="Param" v-if="isOrganization === true || isGroup === true">
                    <span class="Label">
                        Company
                    </span>
                    <span class="Datum--Text">
                        {{ this.localInfo.organization.name }}
                    </span>
                </div>
                <div class="Param" v-if="isOrganization === true">
                    <span class="Label">
                        Phone
                    </span>
                    <span class="Datum--Text">
                        {{ this.localInfo.phone_number }}
                    </span>
                </div>
                <div class="Param">
                    <span class="Label">
                        Email
                    </span>
                    <span class="Datum--Text">
                        {{ this.localInfo.email }}
                    </span>
                </div>
                <div class="Param">
                    <span class="Label">
                        Password
                    </span>
                    <span class="Datum--Text">
                        ••••••••
                    </span>
                    <b-button class="Button" variant="outline-primary" @click="modalPassword = !modalPassword" pill>
                        change password
                    </b-button>

                    <!--MODAL PASSWORD---------------------------------------------------------------------------->
                    <b-modal content-class="ModalPassword" hide-header hide-footer v-model="modalPassword" size="lg" scrollable>
                        <div class="ModalTitle">
                            <h2 class="Text">
                                Change Password
                            </h2>
                            <button class="Close" @click="modalPassword = false">
                                <img class="Image" src="/img/times-solid.svg" />
                            </button>
                        </div>
                        <div class="ModalFormPassword">
                            <div class="Field">
                                <span class="Label">
                                    Current password
                                </span>
                                <b-form-input v-model="currentPassword" type="password" class="Input" required></b-form-input>
                            </div>
                            <div class="Field">
                                <span class="Label">
                                    New password
                                </span>
                                <b-form-input v-model="newPassword" type="password" class="Input" required></b-form-input>
                            </div>
                            <div class="Field">
                                <span class="Label">
                                    Retype new password
                                </span>
                                <b-form-input v-model="ConfirmNewPassword" type="password" class="Input" required></b-form-input>
								<div class="Notification">
									(Must be 8 characters with at least 1 number, 1 letter and no special characters)
								</div>
                            </div>
                        </div>
                        <div class="ModalActionButtons">
                            <b-button class="Cancel" @click="modalPassword = false" variant="primary" pill>
                                cancel
                            </b-button>
                            <b-button class="Save" variant="outline-primary" @click="passwordUpdate()" :disabled="isDisabled === true" pill>
                                change password
                            </b-button>
                        </div>
                    </b-modal>
                    <!--END MODAL PASSWORD------------------------------------------------------------------------>

                </div>
				<div class="Param" v-if="isOrganization === true">
                    <span class="Label">
                        Logo
                    </span>
                    <label class="custom-file-upload id">
                        <input type="file" ref="file" id="fileInput" @change="newLogoUpload()" accept="image/*" />
                        ADD LOGO
                    </label>
                    <span class="FileName">
                        {{ file ? file.name : '' }}
                    </span>
                </div>
            </div>
        </div>

        <div class="BlockCategory" v-if="isPresenter === true || isOrganization === true">
            <span class="Title">
                Membership
            </span>
            <div class="Data">
                <div class="Param" v-if="true">
                    <span class="Label">
                        Plan
                    </span>
                    <span class="Datum--Text">
                        {{ this.subscription.name }} <span v-if="isOrganization === true">with up to {{ this.subscription.users_allowed }} users</span>
                        <span v-else>
                            users
                        </span>
                    </span>
                </div>
				<div class="Param" v-if="isOrganization === true">
                    <span class="Label PresentersLabel">
                        Presenters
                    </span>
					<div class="Progress">
						<div class="Label valid">
							{{ this.localInfo.organization.users }} used out of
							{{ this.subscription.users_allowed }} available
						</div>
						<b-progress class="Bar" :value="this.localInfo.organization.users" :max="this.localInfo.organization.presenter_maximum">
						</b-progress>
					</div>
					<b-button class="Button" variant="outline-primary" @click="modalUpgrade = !modalUpgrade" pill>
                        upgrade
                    </b-button>

					<!--MODAL PLAN-------------------------------------------------------------------------------->
                    <b-modal class="ModalUpgrade" hide-header hide-footer v-model="modalUpgrade" size="lg" scrollable @hide="checkUpgrade = false">
                        <div class="ModalTitle">
                            <h2 class="Text">
                                Upgrade Number of Presenters
                            </h2>
                            <button class="Close" @click="closeModal()">
                                <img class="Image" src="/img/times-solid.svg" />
                            </button>
                        </div>
                        <div class="ModalUpgrade">
							<div class="Period">
								<span class="Text">
									6 Months
								</span>
								<b-form-checkbox class="Switch" v-model="checkUpgrade" name="check-button" size="lg" switch>
								</b-form-checkbox>
								<span class="Text">
									Full Year
								</span>
							</div>
							<div class="PlanList">	
								<div class="Item" :class="{ selectedBorder:selectedRadio == plan.id }" v-for="(plan, index) in this.selectedPlan" :key="index">
									<div class="Title">
										Up to {{ plan.users_allowed }} Users
									</div>
									<div class="Body">
										<div class="Offer">
                                            <span class="Icon">
                                                $
                                            </span>
											<span class="Price">
												{{ formatCurrency(Math.floor(plan.amount)) }}
											</span>
											<span class="Cents">
												00
											</span>
										</div>
										<div class="ForPeriod" v-if="plan.name == '6 months'">
											for {{ plan.name }}
										</div>
										<div class="ForPeriod" v-else>
											per year
										</div>
										<div class="Discount">
											<font-awesome-icon class="Icon" icon="check" />
											({{ plan.description }})
										</div>
										<div class="Select">
											<button class="btn btn-outline-primary Button" :options="plan.id" @click="selectedPlanUpgrade(plan.id, plan.length); selectedRadio = plan.id;">
												Select
											</button>
										</div>
									</div>
								</div>
								
							</div>
							<div class="Contact">
								Over 150 users - 
								<a class="Email" href="mailto:contact@torchmetrics.com">
									contact@torchmetrics.com
								</a>
							</div>
                        </div>
                        <div class="ModalActionButtons">
                            <b-button class="Cancel" @click="closeModal()" variant="primary" pill>
                                cancel
                            </b-button>
                            <b-button class="Save" variant="outline-primary" @click="upgradePlanOrgs()" pill>
                                upgrade
                            </b-button>
                        </div>
                    </b-modal>
                    <!--END MODAL PLAN---------------------------------------------------------------------------->

                </div>
                <div class="Param" v-if="isPresenter === true">
                    <span class="Label">
                        Month/Year Plan
                    </span>
                    <b-form-select class="Datum--Dropdown" v-model="selected" :options="options" @change="selectedPlanUpgrade(id, length);">
                    </b-form-select>
                </div>
                <div class="Param">
                    <span class="Label">
                        Next Payment Amount
                    </span>
                    <span class="Datum--Text">
                        ${{ this.subscription.next_billing_period_amount }}*
                    </span>
                </div>
                <div class="Param" >
                    <span class="Label">
                        Due Date
                    </span>
                    <span class="Datum--Text">
                        {{ formatDate(this.localInfo.expiration_date) }}
                    </span>
                </div>
                <div class="Param">
                    <span class="Label--CardInfo">
                        Payment
                    </span>
                    <div class="CardInfo">
                        <span class="Text">
                            {{ this.subscription.payment_method.card_type }}****{{ this.subscription.payment_method.last_4 }}
                        </span>
                        <span class="ExpData">
                            Expires {{ this.subscription.payment_method.expiration_month }}/{{ this.subscription.payment_method.expiration_year }}
                        </span>
                    </div>
                    <b-button class="Button" variant="outline-primary" @click="modalPayment = !modalPayment" pill>
                        edit
                    </b-button>

                    <!--MODAL PAYMENT----------------------------------------------------------------------------->
                    <b-modal class="ModalPayment" hide-header hide-footer v-model="modalPayment" size="lg" scrollable>
                        <div class="ModalTitle">
                            <h2 class="Text">
                                Edit Payment
                            </h2>
                            <button class="Close" @click="modalPayment = false">
                                <img class="Image" src="/img/times-solid.svg" />
                            </button>
                        </div>
                        <div class="ModalPayCurrent">
                            <div class="CardInfo">
                                <span class="Text">
                                    {{ this.subscription.payment_method.card_type }}****{{ this.subscription.payment_method.last_4 }}
                                </span>
                                <span class="ExpData">
                                    Expires {{ this.subscription.payment_method.expiration_month }}/{{ this.subscription.payment_method.expiration_year }}
                                </span>
                            </div>
                            <div class="ExpDate">
                                <span class="Title">
                                    Expiration Date
                                </span>
                                <b-form-input v-model="CheckExpDate" v-on:keypress="formatCardDate();" maxlength="5" class="hosted-field"></b-form-input>
                            </div>
                        </div>
                        <div class="ModalEditCard">
                            <span class="Title">
                                Edit Credit Card
                            </span>
                            <div class="CardName">
                                <label class="hosted-field--label Label1" for="cardHolderName">
                                    Card Holder Name
                                </label>
                                <div id="cardHolderName" class="hosted-field"></div>
                                <b-form-invalid-feedback>
                                    Card holder name is required and only accepts alphabetic characters (no number or special characters are allowed)
                                </b-form-invalid-feedback>
                            </div>
                            <div class="CardNumber">
                                <label class="hosted-field--label Label1" for="creditCardNumber">
                                    Card Number
                                </label>
                                <div id="creditCardNumber" class="hosted-field"></div>
                                <b-form-invalid-feedback>
                                    Check your credit card number
                                </b-form-invalid-feedback>
                            </div>
                            <div class="ExpDate">
                                <label class="hosted-field--label Label1" for="expireDate">
                                    Expiration Date
                                </label>
                                <div id="expireDate" class="hosted-field"></div>
                                <b-form-invalid-feedback>
                                    Expiration date required
                                </b-form-invalid-feedback>
                            </div>
                            <div class="CVV">
                                <label class="hosted-field--label Label1" for="cvvInput">
                                    CVV
                                </label>
                                <div id="cvvInput" class="hosted-field"></div>
                                <b-form-invalid-feedback>
                                    Security code required
                                </b-form-invalid-feedback>
                            </div>
                        </div>
                        <div class="ModalActionButtons">
                            <b-button class="Cancel" @click="modalPayment = false" variant="primary" pill>
                                cancel
                            </b-button>
                            <b-button class="Save" variant="outline-primary" pill @click="editPayment()">
                                edit payment
                            </b-button>
                        </div>
                    </b-modal>
                    <!--END MODAL PAYMENT------------------------------------------------------------------------->

                </div>
            </div>
            <div class="Clause">
                *Amount includes sales tax <br/>
            </div>
            <div class="Clause--Second">
                Sales tax is subject to change based on your primary account address
            </div>
        </div>

		<div class="BlockCategory" v-if="isGroup === true">
			<span class="Title">
				Groups
			</span>
			<div class="GroupList">
				<div class="Item" v-for="(group, idx) in groups" :key="idx">
					<div class="Name">
						{{ group.name }}
					</div>
					<div class="Presenters">
						{{ group.members }} presenters
					</div>
					<b-button class="ViewButton" variant="outline-primary" @click="modalMembers = !modalMembers; getMembersList(group.id);" pill>
                        view presenters
                    </b-button>
				</div>

				<!--MODAL MEMBERS---------------------------------------------------------------------------->
				<b-modal class="ModalDesactivate" hide-header hide-footer v-model="modalMembers" size="lg" scrollable>
					<div class="ModalTitle">
						<h2 class="Text">
							Training Team
						</h2>
						<button class="Close" @click="modalMembers = false">
							<img class="Image" src="/img/times-solid.svg" />
						</button>
					</div>
					<div class="ModalTeam">
						<div class="MembersList"> <!--v-if="membersList.length !== 0"-->
							<div class="Item" v-for="(member, idx) in membersList" :key="idx">
								<font-awesome-icon class="Icon" icon="angle-right" />
								<div class="User">
									{{ member.full_name }}
								</div>
								<div class="Email">
									{{ member.email }}
								</div>
							</div>
						</div>
						<!--<div class="NoMembers" v-else>
							No members in the current group
						</div>-->
					</div>
					<div class="ModalActionButtons">
						<b-button class="Cancel" @click="modalMembers = false" variant="primary" pill>
							cancel
						</b-button>
						<b-button class="Save" variant="outline-primary" pill>
							update
						</b-button>
					</div>
				</b-modal>
				<!--END MODAL MEMBERS------------------------------------------------------------------------>

			</div>
		</div>

        <div class="ActionButtons">
            <b-button class="Save" variant="primary" @click="saveSettingsActions()" pill>
                save settings
            </b-button>
            <TMGeneralButton
                class="Save cancel-button"
                id="return-dashboard"
                text="CANCEL"
                route="AdminGroups"
                v-if="isGroup === true"
            />
            <b-button class="Desactivate" variant="outline-primary" v-if="isPresenter === true || isOrganization === true" @click="modalDesactivate = !modalDesactivate " pill>
                deactivate account
            </b-button>
            <b-modal class="ModalDelete modalDesactivate" hide-header hide-footer v-model="modalDesactivate" size="lg" scrollable>
                <div class="ModalTitle">
                    <h2 class="Text">
                        Deactivate Account
                    </h2>
                    <button class="Close" @click="modalDesactivate = false">
                        <img class="Image" src="/img/times-solid.svg" />
                    </button>
                </div>
                <div class="ModalDesactivate">
                    Are you sure<br /> you want to deactivate<br /> the account?
                </div>
                <div class="ModalActionButtons">
                    <b-button class="Cancel" @click="modalDesactivate = false" variant="primary" pill>
                        cancel
                    </b-button>
                    <b-button class="Save" variant="outline-primary" @click="unsubscribe()" pill>
                        deactivate
                    </b-button>
                </div>
            </b-modal>
        </div>

        <b-modal class="ModalNotification" hide-header hide-footer no-close-on-backdrop no-close-on-esc v-model="modalNotification" size="md" scrollable>
            <div class="ModalTitle Notification">
                <button class="Close" @click="whereReturn()">
                    <img class="Image" src="/img/times-solid.svg" />
                </button>
            </div>
            <div class="NotificationBody">
                <div class="NotificationIcon">
                    <img src="/img/check-circle.svg" />
                </div>
                <span class="NotificationText">
                    Setting Saved!
                </span>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import { mapActions, mapState } from "vuex";
	import Api from "@/services/api";
    import braintree from "braintree-web";
	import { getAuthorizationToken } from "@/services/utils";
    import { currencyFormatter, formatDate } from "@/services/utils";
    import TMGeneralButton from "@/components/common/TMGeneralButton";

	export default {
		name: "AccountEdit",
        components: {
            TMGeneralButton,
        },
		computed: {
			...mapState(["plans"]),
            //User types
            isPresenter() {
                return this.localInfo.admin === false && this.localInfo.kind === "individual";
            },
            isOrganization() {
                return this.localInfo.admin === true && this.localInfo.kind === "group_manager";
            },
            isGroup() {
                return this.localInfo.admin === false && this.localInfo.kind === "group_manager";
            },
            //Forms validation
            isDisabled() {
                return this.currentPassword == "" 
                    || (this.newPassword == "" && this.ConfirmNewPassword == "") 
                    || (this.newPassword !== this.ConfirmNewPassword) 
                    || this.hasMinimum === false 
                    || this.hasNumber === false 
                    || this.hasLetter === false;
            },
            newPlanDate(){
                let planDate = new Date(this.localInfo.expiration_date);
                planDate.setDate(planDate.getDate() + 1);
                return formatDate(planDate.toString());
            }
		},
        data() {
            return {
                selected: null,
                options: [],
                localInfo: JSON.parse(localStorage.getItem('currentUser')),
                modalPayment: false,
                modalPassword: false,
                modalDesactivate: false,
				modalUpgrade: false,
				modalMembers: false,
                modalNotification: false,
                isSaveSettings: false,
				checkUpgrade: false,
                CheckExpDate:"",
				groups: [],
				plansMonths: [],
				plansYear: [],
				selectedPlan: [],
				selectedNewPlanId: null,
                selectedNewPlanLength: null,
				membersList: [],
				localUser: "user@example.com",
                file: null,
                selectedRadio: null,
                currentPassword: "",
                newPassword: "",
                ConfirmNewPassword: "",
                hasMinimum: false,
                hasNumber: false,
                hasLetter: false,
                subscription: {},
                hostedFieldInstance: false,
                braintreeError: "",
                paymentInfo: {
                    nonce: null,
                },
            }
        },
		methods: {
			...mapActions([
				"GET_PLANS",
                "UPDATE_ORGANIZATION_LOGO"
			]),
            reloadPage() {
                window.location.reload();
            },
			selectedPlanUpgrade(id, length) {
				this.selectedNewPlanId = id;
                this.selectedNewPlanLength = length;
			},  
			getMembersList(id) {
				Api()
					.get('/groups/' + id, {
					headers: {
						Authorization: getAuthorizationToken(),
					},
					})
					.then(res => {
						this.membersList = res.data.users;
					})
					.catch(err => console.log(err));
			},
            newLogoUpload() {
                this.file = this.$refs.file.files[0];
            },
            closeModal() {
                this.modalUpgrade = false;
                this.selectedRadio = null;
            },
            passwordUpdate() {
                const newPassword = {
                    password: this.newPassword
                };

                Api()
                    .put("/passwords/update", newPassword, {
                        headers: {
                            Authorization: getAuthorizationToken(),
                        },
                    })
                    .then((res) => {
                        this.modalNotification = true;
                    })
                    .catch((err) => {
                        console.log(err);
                        alert("Error, try again.");
                    });
            },
            formatCurrency(value) {
                let formatter = currencyFormatter();
                let formaterValue = formatter.format(value);
                let valueNoIcon = formaterValue.replace("$", "");
                return valueNoIcon;
            },
            formatDate: formatDate,
            formatCardDate() {
                var expire_date = this.CheckExpDate;
                if(expire_date.length == 2){
                   this.CheckExpDate = expire_date +'/';
                }
            },
            unsubscribe() {
                const uuid = {
                    subscription_uuid: this.subscription.uuid
                }

                Api()
                    .post("/cancel-subscription", uuid, {
                        headers: {
                            Authorization: getAuthorizationToken(),
                        },
                    })
                    .then((res) => {
                        this.modalNotification = true;
                    })
                    .catch((err) => {
                        console.log(err);
                        alert("Error, try again.");
                    });
            },
            editPayment() {
                this.paymentInfo.nonce = null;
                return new Promise((resolve, reject) => {
                    if (this.hostedFieldInstance) {
                        // Braintree data tokenization.
                        this.hostedFieldInstance
                        .tokenize()
                        .then((payload) => {
                            const payInfo = {
                                subscription_uuid: this.subscription.uuid,
                                payment_nonce: payload.nonce,
                            }

                            Api()
                                .post("/update-payment-method", payInfo, {
                                    headers: {
                                        Authorization: getAuthorizationToken(),
                                    },
                                })
                                .then((res) => {
                                    this.modalNotification = true;
                                })
                                .catch((err) => {
                                    alert("PAYMENT ERROR. Payment was unsuccessful, please check credit card details and try again");
                                });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    }
                });
            },
            upgradePlanOrgs() {
                this.GET_PLANS().then(() => {
                    var currentPlan = this.plans.find(element => element.id === this.subscription.plan_id);
                    let planLenght = currentPlan.length;
                    let isSameLength;

                    if(planLenght === this.selectedNewPlanLength) {
                        isSameLength = true;
                    } else {
                        isSameLength = false;
                    };

                    const planInfo = {
                        subscription_uuid: this.subscription.uuid,
                        new_plan_id: this.selectedNewPlanId,
                        same_lenght: isSameLength,
                    };

                    Api()
                        .post("/change-subscription", planInfo, {
                            headers: {
                                Authorization: getAuthorizationToken(),
                            },
                        })
                        .then((res) => {
                            this.modalNotification = true;
                        })
                        .catch((err) => {
                            // console.log(err);
                            alert(`You already have a change plan pending. Will start on ${formatDate(this.newPlanDate)}`);
                        });
                });
            },
            upgradePlanPres() {
                if(this.subscription.plan_id !== this.selected) {
                    this.GET_PLANS().then(() => {
                    var currentPlan = this.plans.find(element => element.id === this.subscription.plan_id);
                    let planLenght = currentPlan.length;
                    let isSameLength;

                    if(planLenght === this.selectedNewPlanLength) {
                        isSameLength = true;
                    } else {
                        isSameLength = false;
                    };

                    const planInfo = {
                        subscription_uuid: this.subscription.uuid,
                        new_plan_id: this.selected,
                        same_lenght: isSameLength,
                    };

                    Api()
                        .post("/change-subscription", planInfo, {
                            headers: {
                                Authorization: getAuthorizationToken(),
                            },
                        })
                        .then((res) => {
                            this.modalNotification = true;
                        })
                        .catch((err) => {
                            // console.log(err);
                            alert(`You already have a change plan pending. Will start on ${formatDate(this.newPlanDate)}`);
                        });
                    });
                } else {
                    this.$router.push('/user/dashboard'); 
                }
            },
            updateLogo() {
                if(this.file !== null) {
                    const formData = new FormData();
                    formData.append('organization[logo]', this.file);
                    Api()
                        .patch("/organizations/" + this.localInfo.organization_id, formData, {
                            headers: {
                                Authorization: getAuthorizationToken(),
                                'Content-Type': 'multipart/form-data',
                            },
                        })
                        .then((res) => {
                            this.UPDATE_ORGANIZATION_LOGO(res.data.logo);
                            this.modalNotification = true;
                        })
                        .catch((err) => {
                            console.log(err);
                            alert("Error, try again.");
                        });
                } else {
                    this.$router.push('/admin/groups'); 
                }
            },
            saveSettingsActions() {
                this.isSaveSettings = true;
                if(this.isPresenter === true) {
                    this.upgradePlanPres();
                } else if (this.isOrganization === true) {
                    this.updateLogo();
                } else if (this.isGroup === true) {
                    this.$router.push('/admin/groups');
                }else{
                    this.$router.push('/user/dashboard');
                }
            },
            whereReturn() {
                if(this.isSaveSettings === true) {
                    if(this.isPresenter === true) {
                        this.$router.push('/user/dashboard');
                    } else if(this.isOrganization === true) {
                        this.$router.push('/admin/groups');
                    }
                } else {
                    this.reloadPage();
                }
            }
		},
        mounted() {
			this.GET_PLANS().then(() => {
				var plans = this.plans;
				var filterPlans = plans.filter(function(plan) {
					return plan.user_type == "organization";
				});

				var filterByMonths = filterPlans.filter(function(plan) {
					return plan.length == 6;
				});

				var filterByYear = filterPlans.filter(function(plan) {
					return plan.length == 12;
				});

				this.plansMonths = filterByMonths;
				this.plansYear = filterByYear;

				this.selectedPlan = this.plansMonths;

                var filterPlansPres = plans.filter(function(plan) {
					return plan.user_type == "presenter";
				});

                var newOptionsDrop = filterPlansPres.map(function(plan) {
                    var newPlan = {};
                    newPlan.length = plan.length;
                    newPlan.value = plan.id;
                    newPlan.text = "$" + plan.amount + "/" + plan.name + " (" + plan.description + ")";
                    newPlan.description = plan.description;
                    return newPlan;
                });

                this.options = newOptionsDrop;
			});

            Api()
				.get("/organizations/get_groups_by_area_and_manager", {
                    params: {
                        id: this.localInfo.organization_id,
                    },
					headers: {
					    Authorization: getAuthorizationToken(),
					},
				})
				.then((res) => {
                    let groupsList = res.data;
                    this.groups = groupsList.filter(element => element.manager_name === this.localInfo.full_name)
                        .map(element => element.groups)
                        .flat();
				})
				.catch((err) => {
					console.log(err);
				});

            Api()
                .get("get-subscription", {
                    headers: {
					    Authorization: getAuthorizationToken(),
					},
                }).then((res) => {
                    this.subscription = res.data;
                    this.selected = this.subscription.plan_id;

                }).catch((err) => {
                    console.log(err);
                });

            this.localUser = this.localInfo.email;
            //this.selected = this.subscription.plan_id;
        },
		watch: {
            selected: function(val) {
                var newPlanLength = this.options.find(element => element.value === val);
                this.selectedNewPlanLength = newPlanLength.length;
            },
			checkUpgrade: function(val) {
				if (val == true) {
					this.selectedPlan = this.plansYear;
                    this.selectedRadio = null;
				} else {
					this.selectedPlan = this.plansMonths;
                    this.selectedRadio = null;
				}
			},
			modalMembers: function(val) {
				if (val == false) {
					this.membersList = [];
				}
			},
            newPassword: function(val) {
                this.hasMinimum = (val.length > 7);
                this.hasNumber = /\d/.test(val);
                this.hasLetter = /[a-zA-Z]/.test(val);
            },
            modalPayment: function() {
                // Initialize Braintree Hosted Fields.
                braintree.client
                .create({
                    authorization: process.env.VUE_APP_BRAINTREE_API_KEY,
                })
                .then((clientInstance) => {
                    let options = {
                        client: clientInstance,
                        fields: {
                            number: {
                                selector: "#creditCardNumber",
                            },
                            cvv: {
                                selector: "#cvvInput",
                            },
                            expirationDate: {
                                selector: "#expireDate",
                            },
                            cardholderName: {
                                selector: "#cardHolderName",
                            },
                        },
                        styles: {
                            input: {
                            "font-size": "16px",
                            "font-family": "'Lato', sans-serif",
                            padding: "0 0 0 15px",
                            },
                            ".invalid": {
                            "border-color": "red",
                            },
                        },
                    };
                    return braintree.hostedFields.create(options);
                })
                .then((hostedFieldInstance) => {
                    this.hostedFieldInstance = hostedFieldInstance;
                    hostedFieldInstance.on("empty", function (event) {
                        const field = event.fields[event.emittedBy];
                        field.container.classList.remove("notEmpty");
                    });

                    hostedFieldInstance.on("notEmpty", function (event) {
                        const field = event.fields[event.emittedBy];
                        field.container.classList.add("notEmpty");
                    });

                    hostedFieldInstance.on("validityChange", function (event) {
                        const field = event.fields[event.emittedBy];
                        if (field.isValid) {
                            field.container.classList.remove("is-invalid");
                        } else {
                            field.container.classList.add("is-invalid");
                        }
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
            }
		},
	}
</script>

<style style lang="less" scoped>
@import "../../assets/components/account/AccountEdit.less";
</style>